import { ContactForm } from "components/Contact";
import Head from "next/head";
// import getConfig from "next/config"
import { useTranslations } from "use-intl";
import { fetchTranslations } from "utils";
import { generateMetaTags } from "utils/generateMetaTags";
import { fetchTesterProps } from "utils/jmeterTesting";
export default function Contact({
  isTester,
  recaptchaSiteKey,
  servHideContactForm
}) {
  const t = useTranslations("Contact");
  // const { publicRuntimeConfig } = getConfig()

  // Only hide the contact form if the environment variable is explicitly set to "true"
  // This maintains the original behavior (showing the form) by default
  const envHideContactForm = servHideContactForm === "true";
  const translationHideContactForm = t("hide_contact_form") === "true";
  const hideContactForm = envHideContactForm || translationHideContactForm;
  return <div>
      <Head>
        <title>{t("meta.title")} | SeasonalJobs.dol.gov</title>
        <meta name="description" content={t("meta.description")} />
        {generateMetaTags({
        title: t("meta.title"),
        description: t("meta.description")
      })}
      </Head>

      <main id="main-content" className="flex flex-col grid-container sm:px-10 pt-12 pb-20">
        <div className={`mt-6 mb-10 flex flex-col`}>
          <h1 className="font-bold text-4xl xl:text-5xl font-serif">
            {t("heading")}
          </h1>
          <h2 className="mt-6 font-light text-2xl md:text-3xl xl:text-4xl">
            {t("subheading")}
          </h2>
          <div className="text-paragraph with-links mt-10 xl:mt-0" dangerouslySetInnerHTML={{
          __html: t.raw("body")
        }} />
        </div>
        {!hideContactForm && <ContactForm isTester={isTester} recaptchaSiteKey={recaptchaSiteKey} />}
      </main>
    </div>;
}
export async function getServerSideProps({
  locale
}) {
  const contact = await fetchTranslations({
    locale,
    title: "Contact"
  });
  const testerProps = await fetchTesterProps();
  return {
    props: {
      messages: {
        ...contact
      },
      ...testerProps,
      recaptchaSiteKey: process.env.RECAPTCHA_SJ_KEY_V3 || null,
      servHideContactForm: process.env.HIDE_CONTACT_FORM || null
    }
  };
}